/**
 * Pair With — Cuticle Pen add-on (Personalized Pouch PDP).
 *
 * Unlike pair-with-pouch.js (which defers its add until after the main
 * product form submits, since it needs a color + monogram selection first),
 * The Cuticle Pen 3 Pack needs no configuration — so this adds it straight
 * to the cart on click via /cart/add.js, then dispatches the same
 * "cart:change" event the theme's own product-form uses so the cart drawer,
 * cart count, etc. all update exactly as they would for a native add.
 */
class PairWithCuticlePen extends HTMLElement {
  connectedCallback() {
    this.state = 'idle';

    this.idleEl = this.querySelector('[data-pwcp-idle]');
    this.addedEl = this.querySelector('[data-pwcp-added]');
    this.trigger = this.querySelector('[data-pwcp-open]');
    this.variantId = this.getAttribute('data-variant-id');

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-pwcp-open]')) this.add();
      if (event.target.closest('[data-pwcp-again]')) this.reset();
    });
  }

  setState(state) {
    this.state = state;
    if (this.idleEl) this.idleEl.hidden = state !== 'idle';
    if (this.addedEl) this.addedEl.hidden = state !== 'added';
  }

  reset() {
    this.setState('idle');
  }

  async add() {
    if (!this.variantId || this.state === 'adding') return;
    this.setState('idle');
    if (this.trigger) {
      this.trigger.disabled = true;
      this.trigger.textContent = 'Adding…';
    }

    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const body = new FormData();
    body.append('id', this.variantId);
    body.append('quantity', 1);
    body.append('sections', sectionsToBundle.join(','));
    body.append('sections_url', `${Shopify.routes.root}variants/${this.variantId}`);

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    let response;
    try {
      response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }

    if (this.trigger) {
      this.trigger.disabled = false;
      this.trigger.textContent = '+ Add';
    }

    if (!response.ok) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    const responseJson = await response.json();
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent.sections = responseJson.sections;

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent,
        },
      })
    );

    this.setState('added');
  }
}

if (!window.customElements.get('pair-with-cuticle-pen')) {
  window.customElements.define('pair-with-cuticle-pen', PairWithCuticlePen);
}
